module.exports = __webpack_public_path__ + "static/media/lions-logo.c2092d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/lions-logo.png
// module id = 288
// module chunks = 0